import React from 'react';
import { currencies, CurrencyCode } from '../../constants/currencies';
import { UseFormRegister } from 'react-hook-form';

interface AmountInputProps {
  currency: CurrencyCode;
  formattedAmount: string;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  register: UseFormRegister<any>;
  currencyMap: Map<CurrencyCode, number>;
  onInputBlur: () => void;
  autoFocus?: boolean;
}

const AmountInput: React.FC<AmountInputProps> = ({
  currency,
  formattedAmount,
  onInputChange,
  error,
  register,
  currencyMap,
  onInputBlur,
  autoFocus = true
}) => {
  return (
    <div className='w-full'>
      <label>금액</label>
      <div className='w-full flex items-center gap-2'>
        {/* 결제통화 선택 */}
        <select
          id="currency" 
          className='w-[88px] font-mono'
          {...register('currency')}
        >
          {Array.from(currencyMap.keys()).map((currency) => (
            <option key={currency} value={currency}>{currency + ' ' + currencies[currency].name}</option>
          ))}
        </select>
        <input
          id="formattedAmount"
          autoFocus={autoFocus}
          type="text"
          inputMode="decimal"
          step="0.01"
          className="font-bold w-[calc(100%-88px)] font-mono-number"
          style={{color: '#2C7FFF'}}
          value={formattedAmount}
          placeholder={`${currencies[currency].symbol}0`}
          onChange={onInputChange}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === 'Tab') {
              e.preventDefault();
              e.currentTarget.blur();
            }
          }}
          onFocus={(e) => {
            e.currentTarget.select();
          }}
          onBlur={() => {
            onInputBlur()
          }}
        />
      </div>
      {error && <p className="mt-1 ml-2 text-sm text-red-500">{error}</p>}
    </div>
  );
};

export default AmountInput; 